import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import {gridPageRequest} from '../../../../model/common/common.model';
import { Router } from '@angular/router';
import { SalesService } from '../../../../services/sales.service';
import { ManufacturingOrders } from '../../../../model/inventory.model';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { Table } from 'primeng/table';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { InventoryService } from '../../../../services/inventory.service';
import { ReportCenterService } from '../../../../services/report-center.service';

@Component({
  selector: 'app-list-mo',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  providers: [DialogService, MessageService],
  templateUrl: './list-manufacturing-orders.component.html',
  styleUrl: './list-manufacturing-orders.component.scss'
})
export class ListManufacturingOrdersComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  constructor(private route: Router, private salesService: SalesService, private confirmationService: ConfirmationService, private messageService: MessageService, private manufacturingOrdersservice: PurchaseorderService , public ref: DynamicDialogRef, public dialogService: DialogService ,private inventoryService: InventoryService,private reportService : ReportCenterService) { }
  paginator: boolean | undefined;

  products: any[] = [];
  selectedProduct: any[] = [];
  loading: boolean = false;
  loader: boolean = false;
  searchKey: any;
  isDate: boolean = false;
  hide: boolean = false;
  unitLabel: string = '';
  manufacturingOrders: ManufacturingOrders[] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'Manufacturing Order List';
    this.getALLMOList(this.pageRequest);
    this.searchEffect();
    this.getSystemConfigData();
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit'; 
    });
  }

  create() {
    this.route.navigate(['/home/createManufacturingOrders']);
  }

  getALLMOList(query: gridPageRequest) {
    this.loading = true;
    this.manufacturingOrdersservice.getALLPMO('ORDER', this.pageRequest).subscribe(
      (data: any) => {
        if (data) {
          this.manufacturingOrders = data.projectManufacturingBatch.map((batch: {
            projectBoMId: any; projectBOMCode: any; quantity: any; totReqWeight: any; totReqQuantity: any; createdDate: any; projectManufacturingBatchID: any; startDate: any; status: any; projectName: any; ProductBoMId:any; projectBoMName:any; batchNumber:any; fgProductCode:any; fgQuantity:any; wasteQuantity:any; warehouseCode:any;warehouseName:any; createdBy:any; endDate:any }) => ({
            projectBOMCode: batch.projectBOMCode,
            projectName: batch.projectName,
            quantity: batch.quantity,
            batchNumber:batch.batchNumber,
            fgProductCode: batch.fgProductCode,
            wasteQuantity: batch.wasteQuantity,
            warehouseCode: batch.warehouseCode,
            createdBy: batch.createdBy,
            fgQuantity: batch.fgQuantity,
            projectBoMId: batch.projectBoMId,
            projectBoMName:batch.projectBoMName,
            ProductBoMId: batch.ProductBoMId,
            totReqWeight: batch.totReqWeight != null ? Number(batch.totReqWeight) : 0,
            endDate: batch.endDate,
            totReqQuantity: batch.totReqQuantity,
            createdDate: new Date(batch.createdDate).toLocaleDateString('en-GB'),
            startDate: new Date(batch.startDate).toLocaleDateString('en-GB'),
            status: batch.status,
            projectManufacturingBatchID: batch.projectManufacturingBatchID
          }));
          this.loader = false;
        } else {
          this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  updateMO(data?: any) {
    if (data && data.projectManufacturingBatchID) {
      this.route.navigate(['/home/createManufacturingOrders'], { queryParams: { 'projectManufacturingBatchID': data.projectManufacturingBatchID }, skipLocationChange: true });
    } else if (this.manufacturingOrders && this.manufacturingOrders.length > 0 && this.manufacturingOrders[0].projectManufacturingBatchID) {

      this.route.navigate(['/home/createManufacturingOrders'], { queryParams: { 'projectManufacturingBatchID': this.manufacturingOrders[0].projectManufacturingBatchID }, skipLocationChange: true });
    }
}
loadProducts(event: any) {
  if (this.searchKey && this.searchKey.trim() !== '') {
    this.searchManufacturingProjectBom();
  } else {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getALLMOList(this.pageRequest);
  }
}
  deletePMO() {
    if (this.selectedProduct && this.selectedProduct.length > 0) {
      this.confirmationService.confirm({
        header: 'Are you sure?',
        message: 'Please confirm to proceed.',
        accept: () => {
          var projectManufacturingBatchIDs = _.map(this.selectedProduct, 'projectManufacturingBatchID');
          this.loader = true;
          this.manufacturingOrdersservice.deletePMO(projectManufacturingBatchIDs).subscribe({
            next: () => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Project Manufacturing orders deleted successfully.' });
              this.selectedProduct = [];
              this.getALLMOList(this.pageRequest);
              this.loader = false;
            },
            error: error => {
              this.loader = false;
              console.log(error);
            }
          });

          // this.selectedProduct.forEach(product => {
          //   this.manufacturingOrdersservice.deleteMOLineItems({ manufacturingBatchID: product.manufacturingBatchID }).subscribe({
          //     next: () => {
          //       console.log('MOLineItems deleted successfully for Manufacturing Batch ID: ', product.manufacturingBatchID);
          //     },
          //     error: error => {
          //       console.error('Error deleting MOLineItems for Manufacturing Batch ID: ', product.manufacturingBatchID, error);
          //     }
          //   });
          // });
        },
        reject: () => {
          // User rejected, do nothing
        }
      });
    }
  }

  searchManufacturingProjectBom(): void {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    this.loader = true;

    this.salesService.autoSearchManufacturingProjectBom(this.searchKey).subscribe(
      (data: any) => {
        console.log('Response from autoSearchManufacturingProjectBom:', data);

        if (Array.isArray(data)) {
          data.forEach((order: any) => {
            if (order.warehouse && order.warehouse.warehouseName) {
              order.warehouseCode = order.warehouse.warehouseName;
            }
          });

          this.manufacturingOrders = data;
          console.log('Filtered manufacturingOrders:', this.manufacturingOrders);

          this.pageRequest.pageSize = this.manufacturingOrders.length;
          this.paginator = false;
        }
        else if (data && Array.isArray(data.projectManufacturingBatch)) {
          this.manufacturingOrders = data.projectManufacturingBatch;
          console.log('Filtered manufacturingOrders:', this.manufacturingOrders);

          this.pageRequest.pageSize = this.manufacturingOrders.length;
          this.paginator = false;
        }
        else {
          this.manufacturingOrders = [];
          console.warn('No manufacturing batches found or incorrect format', data);
        }

        this.loader = false;
      },
      (error) => {
        console.error('Search error:', error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });  // Show error message
      }
    );
  }

//   refreshData(): void {
//     if (this.dt1) {
//       this.dt1.first = 0;
//     }
//     this.isDate = false;
//     this.getALLMOList(this.pageRequest);
// }


refreshData(): void {
  if (this.dt1) {
    this.dt1.first = 0;
    this.dt1.clear();
  }
  this.searchKey = '';
  this.pageRequest.pageIndex = 0;
  this.pageRequest.pageSize = 50;
  this.getALLMOList(this.pageRequest);
}

// showReport(value:any) {
//   this.ref = this.dialogService.open(matrixLookupComponent, {
//     header: `Project Bill of Material`,
//     width: '80%',
//     data: { projectBoMId: value.projectBoMId, ReportName:'Matrix Form' }

//   });

// }


showReports(value: any): void {
  const formCode = 'ManufacturingBatch';  

  this.reportService.getReportName(formCode).subscribe({
    next: (report: any) => {
      const batchNumber = value.batchNumber;
      const batchNumberStr = batchNumber ? String(batchNumber) : '';
      const sanitizedNumber = batchNumberStr.replace(/[^a-zA-Z0-9]/g, "_");
      document.title = sanitizedNumber;
      this.ref = this.dialogService.open(ReportLookupComponent, {
        header: 'Manufacturing Batch',
        width: '100%',
        data: {
          OrderNo: batchNumberStr,
          ReportName: sanitizedNumber, 
          ReportPath: report.path  
        }
      });
      this.ref.onClose.subscribe(() => {
        document.title = 'Manufacturing Batch List';
      });
    },
    error: (err) => {
      console.error('Report not found for form code:', formCode, err);
    }
  });
}

    getSystemConfigData(): void {
    this.loader = true;
    const appKey = 'hide.columns_Products';
    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response.appKeycode == appKey) {
          if (response.data == 'Y') {
            this.hide = true;
          }
        }
      },
      error: error => {
        console.error('Error fetching System Config Data:', error);
        this.loader = false;
      }
    });
  }


  placeholder: string = 'Search By ';
  private messages: string[] = ['Batch Number','Batch Date', 'Finished Goods', 'Batch Status', 'Finished Date',	'Unit Name',	'Created By'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
